export const WEEKDAYS = ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY"];
const sameBlock = (tour, day, direction) => tour.tag === day && tour.richtung === direction;

export function createTourDraft(tours = []) {
  return tours.map(tour => ({ busId: String(tour.busId), tag: tour.tag, richtung: tour.richtung,
    passengerIds: (tour.stops || []).filter(stop => stop.type === "PICKUP")
      .map(stop => String(stop.passengerId)),
  }));
}

// Each operation returns a fresh draft; nothing changes the saved result.
export function editTourDraft(draft, { busId, days, direction, type, passengerId, targetBusId, delta }) {
  const next = draft.map(tour => ({ ...tour, passengerIds: [...tour.passengerIds] }));
  const id = String(passengerId);
  const getTour = (bus, day) => {
    let tour = next.find(row => String(row.busId) === String(bus) && sameBlock(row, day, direction));
    if (!tour) { tour = { busId: String(bus), tag: day, richtung: direction, passengerIds: [] }; next.push(tour); }
    return tour;
  };
  for (const day of days) {
    const source = getTour(busId, day);
    const index = source.passengerIds.indexOf(id);
    if (type === "add") {
      if (next.some(row => sameBlock(row, day, direction) && row.passengerIds.includes(id))) {
        throw new Error("Der Fahrgast ist an mindestens einem ausgewählten Tag bereits eingeplant. Bitte dort die Funktion Verschieben verwenden.");
      }
      source.passengerIds.push(id);
    } else if (type === "remove") {
      source.passengerIds = source.passengerIds.filter(value => value !== id);
    } else if (type === "move" && index >= 0) {
      if (String(targetBusId) === String(busId)) continue;
      source.passengerIds.splice(index, 1);
      const target = getTour(targetBusId, day);
      if (!target.passengerIds.includes(id)) target.passengerIds.push(id);
    } else if (type === "reorder" && index >= 0) {
      const position = index + delta;
      if (position >= 0 && position < source.passengerIds.length)
        [source.passengerIds[index], source.passengerIds[position]] = [source.passengerIds[position], source.passengerIds[index]];
    }
  }
  return next;
}

export function changedDraftBuses(draft, original) {
  const normalize = tours => new Map(tours.filter(tour => tour.passengerIds.length)
    .map(tour => [`${tour.busId}:${tour.tag}:${tour.richtung}`, JSON.stringify(tour.passengerIds)]));
  const before = normalize(original);
  const after = normalize(draft);
  return [...new Set([...before.keys(), ...after.keys()]
    .filter(key => before.get(key) !== after.get(key)).map(key => key.split(":")[0]))];
}

export function unassignedDraftRides(data, draft) {
  const missing = [];
  const names = new Map(data.passengers.map(passenger => [String(passenger.id), passenger.name]));
  for (const day of WEEKDAYS) for (const direction of ["HIN", "RUECK"]) {
    const expected = new Set();
    for (const tour of data.result.tours) if (sameBlock(tour, day, direction))
      for (const stop of tour.stops || []) if (stop.type === "PICKUP") {
        expected.add(String(stop.passengerId));
        if (!names.has(String(stop.passengerId))) names.set(String(stop.passengerId), stop.passengerName);
      }
    for (const passenger of data.passengers)
      if ((direction === "HIN" ? passenger.hinDays : passenger.rueckDays)?.includes(day)) expected.add(String(passenger.id));
    for (const id of expected) if (!draft.some(tour => sameBlock(tour, day, direction) && tour.passengerIds.includes(id)))
      missing.push({ id, name: names.get(id) || id, day, direction });
  }
  return missing;
}

export function changedDraftDirections(draft, original) {
  return ["HIN", "RUECK"].flatMap(direction => changedDraftBuses(
    draft.filter(tour => tour.richtung === direction),
    original.filter(tour => tour.richtung === direction),
  ).map(busId => `${busId}:${direction}`));
}
